import { useState, useEffect, useContext } from "react";
import { getLocalInfo } from "../services/locals.services";
import { TenantsContext } from "../../../context/tenants.context";

type Feature = {
  id: number;
  nombre: string;
  activo: boolean;
};

const ACCOUNT_TYPES = {
  basic: "Cuenta <b>BÁSICA</b>",
  premium: "Cuenta <b>PREMIUM</b>",
};

const CONFIG = {
  maxPhotos: "maxFotosXPublicacion",
  maxPublicaciones: "maxPublicaciones",
  precioDto: "precioConDto",
  ofrecerPremium: "premium_ofrecerPremium",
  historiasBanner: "historias_banner_imgurl",
  historiasLink: "historias_banner_link",
};

const useLocal = (idLocal: any, token: string) => {
  const { tenant } = useContext(TenantsContext);
  const [localConfig, setLocalConfig] = useState<any>({
    isRetailer: false,
    isWholeSaler: false,
    isPremium: false,
    maxPhotos: 0,
    maxPublicaciones: 0,
    esMinorista: false,
    precioDto: false,
    ofrecerPremium: false,
    usaSku: false,
    shareLink: "",
    shareLinkMinorista: "",
    historiasBanner: "",
    historiasLink: "",
  });

  useEffect(() => {
    if (!idLocal) return;
    getLocalInfo(idLocal, token, tenant)
      .then((response) => response.data.data)
      .then((data) => {
        const maxPhotos = data.config?.find(
          (conf: any) => conf.name === CONFIG.maxPhotos
        ).value;
        const maxOfertas = data.config?.find(
          (conf: any) => conf.name === CONFIG.maxPublicaciones
        ).value;
        const precioAnterior = data.config?.find(
          (conf: any) => conf.name === CONFIG.precioDto
        ).value;
        const showPre = data.config?.find(
          (conf: any) => conf.name === CONFIG.ofrecerPremium
        ).value;
        const historiasBanner = data.config?.find(
          (conf: any) => conf.name === CONFIG.historiasBanner
        ).value;
        const historiasLink = data.config?.find(
          (conf: any) => conf.name === CONFIG.historiasLink
        ).value;
        const retailer = data.caracteristicasList?.find(
          (feat: Feature) => feat.id === 2
        );
        const wholesaler = data.caracteristicasList?.find(
          (feat: Feature) => feat.id === 1
        );
        const minorista = data.caracteristicasList?.find((feat: Feature) =>
          feat.nombre.toLowerCase().includes("minorista")
        );
        const sku = data.caracteristicasList?.find(
          (feat: Feature) => feat.id === 11
        );

        setLocalConfig({
          ...localConfig,
          isRetailer: retailer !== undefined,
          isPremium: data.cuentaTipoNombre === ACCOUNT_TYPES.premium,
          isWholeSaler: wholesaler !== undefined,
          maxPhotos: parseInt(maxPhotos),
          maxPublicaciones: parseInt(maxOfertas),
          esMinorista: minorista !== undefined,
          precioDto: precioAnterior == "true",
          ofrecerPremium: showPre === "true",
          usaSku: sku,
          shareLink: data.shareLink,
          shareLinkMinorista: data.shareLinkMinorista,
          historiasBanner: historiasBanner,
          historiasLink: historiasLink,
        });
      })
      .catch((e) => console.log(e));
  }, [idLocal]);

  return {
    retail: localConfig.isRetailer,
    wholesaler: localConfig.isWholeSaler,
    premium: localConfig.isPremium,
    maxPhotos: localConfig.maxPhotos,
    maxPublicaciones: localConfig.maxPublicaciones,
    esMinorista: localConfig.esMinorista,
    precioDto: localConfig.precioDto,
    ofrecerPremium: localConfig.ofrecerPremium,
    usaSku: localConfig.usaSku,
    shareLink: localConfig.shareLink,
    shareLinkMinorista: localConfig.shareLinkMinorista,
    historiasBanner: localConfig.historiasBanner,
    historiasLink: localConfig.historiasLink,
  };
};

export default useLocal;
